import { useState } from 'react'

import ArrowDownIcon from '@/assets/svg/ArrowDownIcon'
import ArrowUpIcon from '@/assets/svg/ArrowUpIcon'
import useKva, { LANDING_PAGE_LENDING } from '@/hooks/useKVA'

const LIST_FAQ = [
  {
    title: 'Chi phí cho mỗi tháng là bao nhiêu?',
    detail: (
      <p className="text-text-strong text-base font-normal">
        Đây là 1 tính năng mới và sẵn có trên KiotViet, vậy nên khách hàng có thể tự cài đặt tính năng thanh toán QR mà
        sẽ không mất bất kỳ 1 khoản phí nào.
      </p>
    ),
  },
  {
    title: 'Sau khi Khách hàng thanh toán QR thì doanh thu có kết nối với hệ thống báo cáo, quản lý không?',
    detail: (
      <p className="text-text-strong text-base font-normal">
        Có. Chủ cửa hàng hoàn toàn có thể theo dõi báo cáo về nguồn doanh thu từ mã QR tại các báo cáo như Báo cáo cuối
        ngày, Báo cáo bán hàng.
      </p>
    ),
  },
  {
    title: 'Tôi có thể tích hợp bao nhiêu tài khoản ngân hàng?',
    detail: (
      <p className="text-text-strong text-base font-normal">
        Bạn có thể tích hợp không giới hạn tài khoản thanh toán vào phần mềm quản lý.
      </p>
    ),
  },
  {
    title: 'Tôi muốn tìm hiểu thêm những ưu đãi tại đâu?',
    detail: (
      <p className="text-text-strong text-base font-normal">
        Để cập nhật thêm ưu đãi của KiotViet, bạn vui lòng cập nhật <a className="text-brand-primary-500" href={''}>tại đây</a>.
      </p>
    ),
  },
  {
    title: 'Khi gặp khó khăn trong quá trình thanh toán thì tôi liên hệ với ai?',
    detail: (
      <p className="text-text-strong text-base font-normal">
        Gọi tổng đài chăm sóc khách hàng 1900 6522 để được phục vụ 365 ngày/năm từ 7:00 đến 22:00
      </p>
    ),
  },
]

export default function FaQ() {
  return (
    <div
      id="faq"
      className="flex flex-col my-[64px] mx-8 lg:my-[94px] lg:mx-auto gap-14"
    >
      <div
        id="cau-hoi-thuong-gap-title"
        className="text-navy text-center text-[30px] leading-9 font-bold "
      >
        Câu hỏi thường gặp
      </div>
      <div className="flex flex-col items-center lg:w-[955px] md:w-[704px] w-[343px] mx-auto">
        <ul className="flex flex-col text-text-strong p-0 m-0 border-solid border-[#C2C7CE] border-[1px] rounded-[14px]">
          {LIST_FAQ.map((faq, index) => {
            return <Accordion faq={faq} index={index} key={index} isLastItem={index === LIST_FAQ.length - 1} />
          })}
        </ul>
      </div>
    </div>
  )
}

const Accordion = ({ faq, isLastItem }) => {
  const { addEventAction } = useKva()

  const [isOpen, setIsOpen] = useState(false)
  const toggle = () => {
    if (!isOpen) {
      addEventAction(LANDING_PAGE_LENDING, 'open_FAQ', faq.kva)
    }
    setIsOpen(!isOpen)
  }
  const accordionBorderCss = isOpen
    ? 'rounded-[12px] border-[1.5px] border-solid border-brand-primary-500'
    : isLastItem 
      ? ''
      : 'border-b-[1px] border-solid border-b-[#E8EAED]'
  const Arrow = () => (isOpen ? <ArrowUpIcon /> : <ArrowDownIcon />)
  const faqListCss = isOpen ? 'max-h-max rounded-[12px] pt-4 pb-5 ' : 'max-h-0'
  return (
    <li
      className={`relative w-full text-xs sm:text-sm flex items-center flex-wrap select-none ${accordionBorderCss}`}
    >
      <div
        className="flex gap-3 justify-between w-full px-6 py-4 cursor-pointer"
        onClick={toggle}
      >
        <div className="text-base font-semibold max-md:max-w-[259px]">
          {faq.title}
        </div>
        <div className="flex item-center justify-center w-6 h-6">
          <div className="m-auto">
            <Arrow />
          </div>
        </div>
      </div>

      <div
        className={`max-h-0 basis-full border-blue-300 overflow-hidden transition-all select-text px-6 bg-neutral-25 ${faqListCss}`}
      >
        {faq.detail}
      </div>
    </li>
  )
}
